import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class FullscreenService {
	public enterFullscreen(): void {
		return;
		if (
			!this.isFullscreenMode() &&
			typeof document.fullscreenEnabled !== 'undefined' &&
			document.fullscreenEnabled
		) {
			const elem = document.documentElement;
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if ((elem as any).webkitRequestFullscreen) {
				// Safari
				(elem as any).webkitRequestFullscreen();
			} else if ((elem as any).msRequestFullscreen) {
				// IE/Edge
				(elem as any).msRequestFullscreen();
			}
		}
	}

	public exitFullscreen(): void {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if ((document as any).webkitExitFullscreen) {
			// Safari
			(document as any).webkitExitFullscreen();
		} else if ((document as any).msExitFullscreen) {
			// IE/Edge
			(document as any).msExitFullscreen();
		}
	}

	private isFullscreenMode() {
		return typeof document.fullscreenElement !== 'undefined' && document.fullscreenElement !== null;
	}
}
